// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input[data-v-2bc9130d],label[data-v-2bc9130d],ul[data-v-2bc9130d]{color:var(--field-text-color,var(--color-waterloo))}input[data-v-2bc9130d],label[data-v-2bc9130d]{padding-bottom:.5em;padding-top:.5em}label[data-v-2bc9130d]{pointer-events:none}input[data-v-2bc9130d]{border-bottom:1px solid}input[data-v-2bc9130d]:focus{outline:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
